import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
// validation Formik
import * as Yup from "yup";
import { Formik } from "formik";
// import config from "../../config";
import yupconfig from "../../yupconfig";

import { clientdocumentStoreApi } from "../../store/slices/clientdocumentSlice";
// import { removeImage } from "../../store/slices/imageSlice";
import PropTypes from "prop-types";
import { ClientdocumentGridViewApi } from "store/slices/clientdocumentSlice";
import { sweatalert } from "component/Sweatalert2";
import customToast from "component/Toastr";
import { readableApiError } from "helpers/apiError";
import { CLIENT_DOCUMENT_UPLOAD_HELP } from "services/clientDocumentUploadPolicy";

const DocumentUpload = (props) => {
  const [loading, setLoading] = useState(false);
  //   const rightDrawerOpened = useSelector((state) => state.client.isOpenedAddForm);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const page = props.page;
  const initialValues = {
    photo: "",
  };

  const validationSchema = Yup.object().shape({
    //     first_name: Yup.string().trim().max(100).label(t("First Name")).required(),
  });
  yupconfig();

  const hiddenFileInput = React.useRef(null);
  const acceptedDocumentTypes = props.accept || ".pdf,.txt,.doc,.docx,.jpg,.jpeg,.png";

  const handleClick = () => {
    hiddenFileInput.current.click();
  }; // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = async (event) => {
    const fileUploaded = event.target.files;
    let myFiles = Array.from(fileUploaded);
    if (!myFiles.length) return;
    setLoading(true);
    try {
      const action = await dispatch(clientdocumentStoreApi({ myFiles, client_id: props.client_id }));
      if (action.meta.requestStatus === "fulfilled") {
        dispatch(ClientdocumentGridViewApi({ client_id: props.client_id }));
        customToast.success(t("Uploaded successfully"));
      } else if (action.meta.requestStatus === "rejected") {
        const payload = action.payload || {};
        const envelope = payload.message && typeof payload.message === "object"
          ? { ...payload.message }
          : { message: payload.message };
        if (payload.status) envelope.status = payload.status;
        const message = payload.status === 413
          ? CLIENT_DOCUMENT_UPLOAD_HELP
          : readableApiError(envelope, t("Unable to upload document."));
        sweatalert({ title: message, text: message, icon: "error" });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Formik initialValues={initialValues} validationSchema={validationSchema}>
        {(formik) => {
          return (
            <>
              <form noValidate onSubmit={formik.handleSubmit} className="photoform">
                {page === "client-adddocumentform-circle" ? (
                  <a className="add-document cursor-pointer" onClick={handleClick}>
                    {props.label}
                  </a>
                ) : (
                  <button type="button" className="btn btn-outline-primary btn-sm ms-2" onClick={handleClick}>
                    {props.label}
                  </button>
                )}

                <input data-testid="client-document-upload" type="file" accept={acceptedDocumentTypes} ref={hiddenFileInput} onChange={handleChange} style={{ display: "none" }} multiple />
                <button type="submit" className="btn btn-primary w-100 btn-lg d-none" disabled={loading}>
                  {loading && <span className="spinner-border spinner-border-sm"></span>}
                  {t("Upload")}
                </button>
              </form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

DocumentUpload.propTypes = {
  label: PropTypes.string,
  client_id: PropTypes.number,
  page: PropTypes.string,
  accept: PropTypes.string,
};

export default DocumentUpload;
